import React, { useState } from 'react'
import { Row, Col, Button } from 'react-bootstrap'
import useLearningResourceMutations from '../../../hooks/use-learning-resource-mutations'
import useToasts from '../../../hooks/use-toasts'
import Spinner from '../../common/spinner-container'
import Title from './title'
import Description from './description'
import Type from './type'
import Url from './url'
import Dimensions from './dimensions'
import ModeSelector from '../../common/button-selector'
import CardView from '../../learning-resources/card'
import SpinnerButton from '../../common/spinner-button'

const InputRow = ({ children }) => (<Row><Col>{children}</Col></Row>)

const MODES = {
    EDIT: 'edit',
    PREVIEW: 'preview',
}

const EditLearningResourceForm = ({
    resourceId,
    onComplete = () => {},
}) => {

    const [ mode, setMode ] = useState(MODES.EDIT)

    const {
        toastSuccess,
        toastError,
    } = useToasts({
        successMessage: 'Learning resources saved!',
        errorMessage: 'Error saving resource.',
        onSuccess: onComplete,
    })

    const {
        resource,
        setResource,
        isLoading,
        isSaving,
        saveResource,
    } = useLearningResourceMutations({
        resourceId,
        onSuccess: toastSuccess,
        onError: toastError,
    })

    if (isLoading) {
        return (
            <Spinner label='Loading...' />
        )
    }

    const renderPreview = () => {
        return (
            <CardView resource={resource} />
        )
    }

    const renderEdit = () => {
        return (
            <React.Fragment>
                <Title value={resource} onChange={setResource} />
                <Description value={resource} onChange={setResource} />
                <Dimensions value={resource} onChange={setResource} />
                <Type value={resource} onChange={setResource} />
                <Url value={resource} onChange={setResource} />
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-evenly'
                    }}
                >
                    <Button variant="secondary" disabled={isSaving} onClick={onComplete}>
                        {resource.id ? 'Discard Changes' : 'Discard' }
                    </Button>
                    <SpinnerButton busy={isSaving} disabled={isSaving} onClick={() => saveResource()}>
                        {isSaving ? 'Saving...' : 'Save Resource'}
                    </SpinnerButton>
                </div>
            </React.Fragment>
        )
    }

    const renderMode = () => {
        switch (mode) {
        case MODES.PREVIEW: return renderPreview()
        default: return renderEdit()
        }
    }

    return (
        <div
            style={{
                padding: '30px'
            }}
        >
            <div className='text-center'>
                <ModeSelector options={Object.values(MODES)} value={mode} onChange={setMode} />
            </div>
            <h2>{resourceId ? 'Update Learning Resource' : 'Create Learning Resource'}</h2>
            {renderMode()}
           
        </div>
    )
}

export default EditLearningResourceForm